"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { DetailInfoList } from "@shared/ui/detail-info-list";
import { DetailInfoListItem } from "@shared/ui/detail-info-list-item";
import { StatusBadge } from "@shared/ui/status-badge";
import { WorkingHours } from "@shared/ui/working-hours";
import { formatCapacity, formatLength } from "@shared/utils/format-trail-info";
import { getStatusLabel } from "@shared/utils/get-status-label";

import type { TrailPageType } from "../../../model";

import s from "./trail-info-list-section.module.scss";

export type TrailInfoListSectionProps = ComponentProps<"div"> & {
  className?: string;
  trailStatus: TrailPageType["trailStatus"];
  length?: TrailPageType["length"];
  workingHours: TrailPageType["workingHours"];
  start?: TrailPageType["start"];
  startDescription?: TrailPageType["startDescription"];
  end?: TrailPageType["end"];
  endDescription?: TrailPageType["endDescription"];
  ascentTime: TrailPageType["ascentTime"];
  descentTime: TrailPageType["descentTime"];
  capacity: TrailPageType["capacity"];
  difficulty: TrailPageType["difficulty"];
};

export const TrailInfoListSection = (props: TrailInfoListSectionProps) => {
  const {
    className,
    trailStatus,
    workingHours,
    start,
    startDescription,
    end,
    endDescription,
    ascentTime,
    descentTime,
    capacity,
    length,
  } = props;

  const startValue = startDescription
    ? `Начало (${startDescription})`
    : "Начало";

  const endLabel = endDescription ? `Конец (${endDescription})` : "Конец";

  return (
    <DetailInfoList className={clsx(s.root, className)}>
      <DetailInfoListItem title="Статус">
        <StatusBadge variant={trailStatus}>
          {getStatusLabel(trailStatus)}
        </StatusBadge>
      </DetailInfoListItem>
      <DetailInfoListItem title="Протяженность">
        {formatLength(length)}
      </DetailInfoListItem>
      {start && (
        <DetailInfoListItem title={startValue}>
          {formatLength(start.toString())}
        </DetailInfoListItem>
      )}
      {end && (
        <DetailInfoListItem title={endLabel}>
          {formatLength(end.toString())}
        </DetailInfoListItem>
      )}
      {workingHours && (
        <DetailInfoListItem title="График работы">
          <WorkingHours
            workingHours={workingHours}
            ascentTime={ascentTime}
            descentTime={descentTime}
          />
        </DetailInfoListItem>
      )}
      {capacity && (
        <DetailInfoListItem title="Пропускная способность">
          {formatCapacity(capacity)}
        </DetailInfoListItem>
      )}
    </DetailInfoList>
  );
};

TrailInfoListSection.displayName = "TrailInfoListSection";
